import { render, staticRenderFns } from "./TemplateFieldTypesModal.vue?vue&type=template&id=386b3800&scoped=true"
import script from "./TemplateFieldTypesModal.vue?vue&type=script&lang=js"
export * from "./TemplateFieldTypesModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateFieldTypesModal.vue?vue&type=style&index=0&id=386b3800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b3800",
  null
  
)

export default component.exports